module.exports = __webpack_public_path__ + "static/cai-stacked-no-text-ba11daaeb1fc07a8256f8427204345b0.png";